export * from './schemas'



/** WEBPACK FOOTER **
 ** ./src/services/schemas/index.js
 **/